import * as yup from 'yup'

export const schema = yup.object().shape({
  fulfillmentCenterId: yup.number(),
  modelId: yup.string().optional().matches(/^([0-9]+)?$/, 'O modelo deve ser numérico').trim(),
  code: yup.string().trim(),
  barcode: yup.string().trim(),
})
